import { InvoiceImportIcon } from './InvoiceImportIcon';

/**
 * author: Jeff Anders
 * id 28766FCF-01FB-43EF-AAE4-B78A644880AF
 * name invoice-import
 * version: 7.4.47
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/invoice-import.svg
 * tags
 * - Banking 
 * - Shopping 
 */
export const InvoiceInboundIcon = InvoiceImportIcon;
export default InvoiceInboundIcon